/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { FieldEnumList } from '../data/models';

const defaultCheckBox = {
  entityType: 'CUSTOMER_ADDRESS',
  isUnique: false,
  options: [],
  multilineCount: 0,
  validateRules: [],
  defaultValue: false,
  fieldType: FieldEnumList.BOOLEAN,
  className: '',
  required: false,
  orderNumber: 90,
  isHidden: false,
};

export const defaultShippingCheckBox = {
  ...defaultCheckBox,
  label: 'Set as default shipping address',
  name: 'default_shipping',
  id: 'default_shipping',
  code: 'default_shipping',
  customUpperCode: 'defaultShipping',
};

export const defaultBillingCheckBox = {
  ...defaultCheckBox,
  label: 'Set as default billing address',
  name: 'default_billing',
  id: 'default_billing',
  code: 'default_billing',
  customUpperCode: 'defaultBilling',
};
